// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"59694841","381":"98704d09","595":"063b9afa","691":"b25d6b5b","787":"95fc37de"}[chunkId] + ".chunk.js";
};